import React from 'react';
import { useWindowDimensions } from 'react-native';

import { DefaultTheme, NavigationContainer, NavigationIndependentTree } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';

import { Box } from '@/components/lib/components';
import { defaultBgColor as modalBgColor } from '@/feature/alerts/components/Modal';

import { GameResult } from '../GameResultItem';
import { GameResultDetails } from './GameResultDetails';
import { GameResultMatchup } from './GameResultMatchup';

type GameResultModalContentProps = {
    gameResult: GameResult;
    onNavigationChange: (index: number) => void;
    customHandle?: React.ReactNode;
};

export type P2pLeaderboardParamList = {
    GameResultMatchup: undefined;
    GameResultDetails: undefined;
};

const Stack = createStackNavigator<P2pLeaderboardParamList>();

export const GameResultModalContent = ({
    gameResult,
    onNavigationChange,
    customHandle,
}: GameResultModalContentProps) => {
    const { height } = useWindowDimensions();
    return (
        <Box height={height}>
            <NavigationIndependentTree>
                <NavigationContainer
                    theme={{
                        ...DefaultTheme,
                        // We need to set the background color to the same as the modal background color
                        // otherwise, the screen will flicker when navigating back
                        colors: { ...DefaultTheme.colors, background: modalBgColor },
                    }}
                >
                    <Stack.Navigator
                        initialRouteName="GameResultMatchup"
                        screenOptions={{
                            cardStyle: {
                                backgroundColor: modalBgColor,
                            },
                            headerShown: false,
                        }}
                    >
                        <Stack.Screen name="GameResultMatchup">
                            {({ navigation }) => (
                                <GameResultMatchup
                                    gameResult={gameResult}
                                    onIconPress={() => {
                                        navigation.navigate('GameResultDetails');
                                        onNavigationChange(1);
                                    }}
                                />
                            )}
                        </Stack.Screen>
                        <Stack.Screen name="GameResultDetails">
                            {({ navigation }) => (
                                <>
                                    {customHandle}
                                    <GameResultDetails
                                        gameResult={gameResult}
                                        onArrowPress={() => {
                                            navigation.goBack();
                                            onNavigationChange(0);
                                        }}
                                    />
                                </>
                            )}
                        </Stack.Screen>
                    </Stack.Navigator>
                </NavigationContainer>
            </NavigationIndependentTree>
        </Box>
    );
};
